<div class="kanban-dashboard-page">
  <ng-container *ngIf="usaKanban; else kanbanDisabled">
    <div class="dashboard-header">
      <div>
        <h1>CRM &gt; Dashboard</h1>
        <p>Resumo dos cards, etapas, vendedores, produtos e relatorio geral por formulario.</p>
      </div>

      <div class="dashboard-actions">
        <label>
          Formulario
          <select class="form-control" [(ngModel)]="formularioSelecionado" (ngModelChange)="carregar()" [disabled]="carregando">
            <option *ngFor="let formulario of report.formularios" [ngValue]="formulario.id">{{ formulario.nome }}</option>
          </select>
        </label>
        <label for="dashboard-data-inicial">
          Data inicial
          <input id="dashboard-data-inicial" class="form-control" type="date" [(ngModel)]="dataInicial" [disabled]="carregando" min="0001-01-01" max="9999-12-30" required />
        </label>
        <label for="dashboard-data-final">
          Data final
          <input id="dashboard-data-final" class="form-control" type="date" [(ngModel)]="dataFinal" [disabled]="carregando" min="0001-01-01" max="9999-12-30" required />
        </label>
        <button class="btn btn-outline-primary" type="button" (click)="restaurarPeriodo()" [disabled]="carregando">Últimos 30 dias</button>
        <button class="btn btn-outline-secondary" type="button" (click)="voltarKanban()">Voltar</button>
        <button class="btn btn-primary" type="button" (click)="carregar()" [disabled]="carregando">Aplicar filtros</button>
      </div>
    </div>

    <p class="dashboard-periodo" *ngIf="periodoAplicado && !carregando && !erroFiltro">Período aplicado: <strong>{{ periodoAplicado }}</strong> · Data de criação dos cards. Altere as datas e clique em Aplicar filtros.</p>
    <div class="alert alert-danger" role="alert" *ngIf="erroFiltro">{{ erroFiltro }}</div>
    <div class="dashboard-loading" *ngIf="carregando">Carregando dashboard...</div>

    <ng-container *ngIf="!carregando && !erroFiltro">
      <div class="metric-grid">
        <div class="metric-card">
          <span>Total de cards</span>
          <strong>{{ totalCards }}</strong>
        </div>
        <div class="metric-card">
          <span>Em aberto</span>
          <strong>{{ totalAbertos }}</strong>
        </div>
        <div class="metric-card">
          <span>Ganhos</span>
          <strong>{{ totalGanhos }}</strong>
        </div>
        <div class="metric-card">
          <span>Perdidos</span>
          <strong>{{ totalPerdas }}</strong>
        </div>
        <div class="metric-card">
          <span>Atrasados</span>
          <strong>{{ totalAtrasados }}</strong>
        </div>
        <div class="metric-card">
          <span>Tempo medio aberto</span>
          <strong>{{ tempoMedioAberto }} dias</strong>
        </div>
        <div class="metric-card">
          <span>Conversao de ganho</span>
          <strong>{{ conversaoGanho | number:'1.1-1' }}%</strong>
        </div>
      </div>

      <div class="dashboard-grid">
        <section class="dashboard-panel span-2">
          <div class="panel-title">
            <h2>Funil por etapa</h2>
            <span>{{ totalCards }} cards</span>
          </div>

          <div class="bar-list">
            <div class="bar-row" *ngFor="let item of funilPorEtapa">
              <div class="bar-label">{{ item.label }}</div>
              <div class="bar-track">
                <div class="bar-fill blue" [style.width.%]="item.percent"></div>
              </div>
              <div class="bar-value">{{ item.value }}</div>
            </div>
          </div>
        </section>

        <section class="dashboard-panel">
          <div class="panel-title">
            <h2>Aging dos cards</h2>
          </div>

          <div class="bar-list compact">
            <div class="bar-row" *ngFor="let item of agingCards">
              <div class="bar-label">{{ item.label }}</div>
              <div class="bar-track">
                <div class="bar-fill" [class.red]="item.label === '+15 dias'" [style.width.%]="item.percent"></div>
              </div>
              <div class="bar-value">{{ item.value }}</div>
            </div>
          </div>
        </section>

        <section class="dashboard-panel">
          <div class="panel-title">
            <h2>Movimento diario</h2>
          </div>

          <div class="daily-chart">
            <div class="daily-item" *ngFor="let item of movimentoDiario">
              <div class="daily-bar" [style.height.%]="item.percent">
                <span>{{ item.value }}</span>
              </div>
              <small>{{ item.label }}</small>
            </div>
          </div>
        </section>

        <section class="dashboard-panel">
          <div class="panel-title">
            <h2>Produtividade por vendedor</h2>
            <span>Top 10</span>
          </div>

          <div class="seller-chart">
            <div class="seller-column" *ngFor="let seller of produtividadeVendedor">
              <div class="seller-bars">
                <div class="seller-bar-wrap">
                  <span>{{ seller.total }}</span>
                  <div class="seller-bar total" [style.height.%]="produtividadeAltura(seller.total)"></div>
                </div>
                <div class="seller-bar-wrap">
                  <span>{{ seller.ganhos }}</span>
                  <div class="seller-bar win" [style.height.%]="produtividadeAltura(seller.ganhos)"></div>
                </div>
                <div class="seller-bar-wrap">
                  <span>{{ seller.perdas }}</span>
                  <div class="seller-bar loss" [style.height.%]="produtividadeAltura(seller.perdas)"></div>
                </div>
              </div>
              <strong [title]="seller.nome">{{ seller.nome }}</strong>
              <div class="seller-legend">
                <span class="legend-total">Total</span>
                <span class="legend-win">Ganho</span>
                <span class="legend-loss">Perda</span>
              </div>
            </div>
          </div>
        </section>

        <section class="dashboard-panel">
          <div class="panel-title">
            <h2>Cards criticos</h2>
            <span>{{ cardsCriticos.length }} atrasados</span>
          </div>

          <div class="critical-list">
            <div class="critical-row" *ngFor="let negocio of cardsCriticos">
              <span class="status-pill status-perda">{{ diasDesde(negocio.data_criacao) }} dias</span>
              <strong>ID: {{ negocio.id }} - {{ negocio.nome_negocio }}</strong>
              <small>{{ negocio.etapa_nome }} - {{ negocio.seller_responsavel_nome }}</small>
            </div>
          </div>
        </section>
      </div>

      <section class="dashboard-panel report-panel">
        <div class="panel-title report-title">
          <div>
            <h2>Relatorio geral dos cards</h2>
            <p>Dados do formulario selecionado com todos os campos configurados.</p>
          </div>
          <div class="report-actions">
            <span>{{ report.linhas.length }} registro(s)</span>
            <button class="btn btn-success" type="button" (click)="exportarExcel()" [disabled]="report.linhas.length === 0">Exportar Excel</button>
          </div>
        </div>

        <div class="report-table-wrap">
          <table class="report-table">
            <thead>
              <tr>
                <th>DATA ABERTURA</th>
                <th>ID</th>
                <th>STATUS</th>
                <th>ETAPA</th>
                <th *ngFor="let campo of camposRelatorio">{{ campo.nome }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let linha of report.linhas">
                <td>{{ formatarData(linha.data_abertura) }}</td>
                <td>{{ linha.id }}</td>
                <td><span class="status-pill" [ngClass]="classeStatus(linha.status)">{{ linha.status }}</span></td>
                <td>{{ linha.etapa }}</td>
                <td *ngFor="let campo of camposRelatorio">{{ valorCampo(linha, campo) }}</td>
              </tr>
              <tr *ngIf="report.linhas.length === 0">
                <td [attr.colspan]="4 + camposRelatorio.length">Nenhum card encontrado para o formulario selecionado.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </ng-container>
  </ng-container>

  <ng-template #kanbanDisabled>
    <div class="kanban-disabled">
      Kanban nao habilitado para este cliente.
    </div>
  </ng-template>
</div>
